<template>
  <div class="flex flex_between">
    <md-field :class="{ 'select-error': isError }">
      <label>{{$t('seller.upload.manual.option.select.title')}}*</label>
      <TbSelect v-model="typeId"
				@md-selected="onSelect"
				:search-allow="false"
				:options="options"
				options-value-field="num"
				:options-display-getter="(item) => $t(item.title)"
      />
    </md-field>
  </div>
</template>
<script>
import enumStatus from "@/common/enum";

export default {
  props: {
    typeId: [String, Number]
  },
  data() {
    return {
		typeValue: "",
		options: enumStatus.upTypeList
	}
  },
  mounted() {
    this.typeValue = this.typeId;
  },
  methods: {
    onSelect() {
      this.$emit("onSelect", this.typeValue);
    }
  },
  watch: {
    typeId() {
      this.typeValue = this.typeId;
    }
  }
};
</script>
